import { Controller } from '@hotwired/stimulus'
import { parsePastedList } from '../helpers'

export default class extends Controller {
  static targets = ['list', 'template', 'row']

  add (event) {
    event.preventDefault()
    const row = this.buildRow('')
    this.listTarget.appendChild(row)
    row.querySelector('input')?.focus()
  }

  remove (event) {
    event.preventDefault()
    if (this.rowTargets.length <= 1) return
    const row = event.target.closest('[data-options-list-target="row"]')
    if (row) row.remove()
  }

  paste (event) {
    const items = this.itemsFrom(event)
    if (items.length <= 1) return

    event.preventDefault()
    const input = event.target
    input.value = items[0]

    const rows = items.slice(1).map((item) => this.buildRow(item))
    const currentRow = input.closest('[data-options-list-target="row"]')
    if (currentRow) currentRow.after(...rows)
    else this.listTarget.append(...rows)
  }

  pasteIntoOptions (event) {
    if (!this.hasListTarget) return

    const items = this.itemsFrom(event)
    if (items.length <= 1) return

    event.preventDefault()
    const rows = items.map((item) => this.buildRow(item))
    const blank = this.rowTargets.find((row) => !row.querySelector('input').value.trim())

    if (blank) blank.replaceWith(...rows)
    else this.listTarget.append(...rows)
  }

  enterNext (event) {
    event.preventDefault()
    const row = event.target.closest('[data-options-list-target="row"]')
    const next = this.rowTargets[this.rowTargets.indexOf(row) + 1]

    if (next) {
      next.querySelector('input').focus()
    } else {
      this.add(event)
    }
  }

  tabNext (event) {
    if (event.shiftKey) return
    const row = event.target.closest('[data-options-list-target="row"]')
    if (row !== this.rowTargets[this.rowTargets.length - 1]) return
    event.preventDefault()
    this.add(event)
  }

  // Private

  itemsFrom (event) {
    return parsePastedList(event.clipboardData?.getData('text/plain') ?? '')
  }

  buildRow (value) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = this.templateTarget.innerHTML.trim()
    const row = wrapper.firstElementChild
    row.querySelector('input').value = value
    return row
  }
}
